import React, { useState, useEffect } from "react";

import { alertLifetime, closesOnClick, needsRoom } from "../services/alerts";
import { Redirect, Switch, Route, useLocation } from "react-router-dom";

import "../css/alert.css"
import "../css/loader.css"

import ErrorBoundary from "./ErrorBoundary";
import Login from "./Login";
import Viewer from "./Viewer";

function Main(props) {
    const [accessToken, setAccessToken] = useState(localStorage.getItem("accessToken"))
    const [refreshToken, setRefreshToken] = useState(localStorage.getItem("refreshToken"))
    const [auth, setAuth] = useState(localStorage.getItem("auth"))

    const [showLoader, setShowLoader] = useState(false) // The full-screen spinner

    const [showAlert, setShowAlert] = useState(false) // The message at the foot of the page
    const [message, setMessage] = useState("")
    const [severity, setSeverity] = useState("")

    const [showUser, setShowUser] = useState(localStorage.getItem("user")) // Mostrar nombre de user logeado

    const changeAlert = () => {
        let alert = document.getElementById("alert")
        let btnClose = document.getElementById("btn-close")

        if (severity === "info") {
            alert.classList.remove("alert-warning", "alert-warning-pilot", "alert-danger", "alert-danger-scope", "alert-success")
            alert.classList.add("alert-info")

            btnClose.classList.remove("btn-close-warning", "btn-close-warning-pilot", "btn-close-danger", "btn-close-danger-scope", "btn-close-success")
            btnClose.classList.add("btn-close-info")
        }
        else if (severity === "warning") {
            alert.classList.remove("alert-info", "alert-warning-pilot", "alert-danger", "alert-danger-scope", "alert-success")
            alert.classList.add("alert-warning")

            btnClose.classList.remove("btn-close-info", "btn-close-warning-pilot", "btn-close-danger", "btn-close-danger-scope", "btn-close-success")
            btnClose.classList.add("btn-close-warning")
        }
        else if (severity === "warning-pilot") {
            alert.classList.remove("alert-info", "alert-warning", "alert-danger", "alert-danger-scope", "alert-success")
            alert.classList.add("alert-warning-pilot")

            btnClose.classList.remove("btn-close-info", "btn-close-warning", "btn-close-danger", "btn-close-danger-scope", "btn-close-success")
            btnClose.classList.add("btn-close-warning-pilot")
        }
        else if (severity === "danger") {
            alert.classList.remove("alert-info", "alert-warning", "alert-warning-pilot", "alert-danger-scope", "alert-success")
            alert.classList.add("alert-danger")

            btnClose.classList.remove("btn-close-info", "btn-close-warning", "btn-close-warning-pilot", "btn-close-danger-scope", "btn-close-success")
            btnClose.classList.add("btn-close-danger")
        }
        else if (severity === "danger-scope") {
            alert.classList.remove("alert-info", "alert-warning", "alert-warning-pilot", "alert-danger", "alert-success")
            alert.classList.add("alert-danger-scope")

            btnClose.classList.remove("btn-close-info", "btn-close-warning", "btn-close-warning-pilot", "btn-close-danger", "btn-close-success")
            btnClose.classList.add("btn-close-danger-scope")
        }
        else if (severity === "success") {
            alert.classList.remove("alert-info", "alert-warning", "alert-warning-pilot", "alert-danger", "alert-danger-scope")
            alert.classList.add("alert-success")

            btnClose.classList.remove("btn-close-info", "btn-close-warning", "btn-close-warning-pilot", "btn-close-danger", "btn-close-danger-scope")
            btnClose.classList.add("btn-close-success")
        }
    }

    // Mostrar u ocultar alert de error de usuario
    const closeAlert = () => {
        setShowAlert(false) // What the alert's own button calls.
    }

    // How long an alert stays, and what dismisses it. Both used to be set
    // during the render: a timer on every render while one was shown, and a
    // window listener added on every render and never removed, so a message
    // could be closed by a click anywhere and by whichever timer fired first.
    useEffect(() => {
        if (!showAlert) return;

        const timer = setTimeout(() => closeAlert(), alertLifetime(message));

        const dismiss = () => { if (closesOnClick(message)) closeAlert(); };
        window.addEventListener("click", dismiss);

        return () => {
            clearTimeout(timer);
            window.removeEventListener("click", dismiss);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showAlert, message]);

    // A message that does not fit needs a box that grows with it; the fixed
    // 340 by 45 of .alert cut off both a list and one long sentence.
    useEffect(() => {
        const alert = document.getElementById("alert");
        if (!alert) return;
        alert.classList.toggle("alert-roomy", needsRoom(message));
    }, [message]);

    useEffect(() => {
        changeAlert() // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [severity]);

    const location = useLocation();
    const [pathname, setPathname] = useState(location.pathname);

    const [paths, setPaths] = useState(localStorage.getItem("customPaths") ? localStorage.getItem("customPaths").split(",") : ["/inicio-sesion", "/visor-rpd"]);

    useEffect(() => {
        setPathname(location.pathname);
    }, [location]);

    return (
        <>{paths.length > 2 ?
            <Redirect to={{ pathname: auth ? (paths.slice(2).includes(pathname) ? pathname : paths.slice(2)[0]) : paths[0], state: { from: props.location } }} />
            :
            <Redirect to={{ pathname: auth ? paths[1] : paths[0], state: { from: props.location } }} />
        }
            <ErrorBoundary>
                <Switch>
                    <Route exact path={paths[0]}>
                        <Login
                            setAccessToken={setAccessToken}
                            setRefreshToken={setRefreshToken}
                            setAuth={setAuth}
                            setShowLoader={setShowLoader}
                            setShowAlert={setShowAlert}
                            setMessage={setMessage}
                            setSeverity={setSeverity}
                            setShowUser={setShowUser}
                            closeAlert={closeAlert}
                        />
                    </Route>
                    <Route path={paths[1]}>
                        <Viewer
                            setAccessToken={setAccessToken}
                            setRefreshToken={setRefreshToken}
                            accessToken={accessToken}
                            refreshToken={refreshToken}
                            setAuth={setAuth}
                            setShowLoader={setShowLoader}
                            setShowAlert={setShowAlert}
                            setMessage={setMessage}
                            setSeverity={setSeverity}
                            showUser={showUser}
                            setShowUser={setShowUser}
                            paths={[paths, setPaths]}
                            pathname={pathname}
                        />
                    </Route>
                </Switch>
            </ErrorBoundary>
            <div style={{ display: showLoader ? null : "none" }} className="lds-ring loader" id="loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <div className="alert-container">
                <div style={{ display: showAlert ? null : "none" }} className="alert" id="alert">
                    <div className="content-icon-info">
                        {severity === 'info' ? <ion-icon name="alert-circle-outline"></ion-icon>
                            : severity === 'warning' ? <ion-icon name="alert-circle-outline"></ion-icon>
                                : severity === 'warning-pilot' ? <ion-icon name="warning-outline"></ion-icon>
                                    : severity === 'danger' ? <ion-icon name="warning-outline"></ion-icon>
                                        : severity === 'danger-scope' ? <ion-icon name="warning-outline"></ion-icon>
                                            : severity === 'success' ? <ion-icon name="checkmark-circle-outline"></ion-icon>
                                                : null
                        }
                    </div>
                    <span className="alert-text">{message}</span>
                    <div className="content-icon-exit">
                        <button className="btn-close" id="btn-close" onClick={() => closeAlert()}>
                            <ion-icon name="close-outline"></ion-icon>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Main;